<template>
  <div class="div-input">
    <svg class="icon-search">
      <use v-bind="{ href: '#icons_' + nameIcon }" />
    </svg>
    <div class="relative w-100">
      <input
        class="input-search"
        ref="input"
        type="text"
        @focus="
          setVKB(false);
          loadIndex();
        "
        @blur="freeIndex"
        @keydown="keydownInner"
        :placeholder="$t('searchInput.placeHolder')"
        v-select.focus
      />
      <div
        class="otz-icon icon-otzar no-bg icon-clear noactive"
        :style="{ left: showVirtualKeyBoard ? '34px' : '14px' }"
        v-if="searchTxt.length > 0"
        @click="clearTxt"
      >
        F
      </div>
      <BaseIcon
        v-if="showVirtualKeyBoard"
        class="keyboard-icon"
        nameIcon="keyboard"
        pathIcon="k"
        :height="20"
        :width="20"
        v-tooltip="$t('mainTools.keyboardOnScreen')"
        @click="setVKB"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import * as bookList from "@/store/modules/bookList.js";
import mixBooksIndexManager from "@/mixing/mixSearchIndexMemoryManager.js";
import mixInputCharsTranslate from "@/mixing/mixInputCharsTranslate";
let timeout, timeoutSetActive;
export default {
  mixins: [mixBooksIndexManager, mixInputCharsTranslate],
  data() {
    return {
      // txtSearch: "",
      nameIcon: "icon-input-search",
      nameopen: "open-list",
      bookname: "bookname",
      searchResults: [],
      searchTxt: "",
    };
  },
  computed: {
    ...mapState("vKeyBoard", ["vKeyBoardInput", "vKeyBoardInputName"]),
    ...mapState("bookList", ["textSearch", "searchByIds", "setFocusInInput"]),
    ...mapGetters("bookList", ["getTextSearchInput"]),
    showVirtualKeyBoard() {
      const react = this.$store.state.inputKeyboardChange;
      return localStorage.getItem("virtualKeyBoard") == "1";
    },
    showVKB() {
      let mode = this.userSettings.settings.virtualKeyBoard;
      return mode && mode == "1" ? true : false;
    },
  },
  methods: {
    ...mapActions("bookList", [
      "setSearchTo",
      "toggleSearchMode",
      "setLastPinTo",
      "setDoNotFocus",
    ]),
    ...mapActions("booklistComp", ["setFirstActive"]),
    ...mapActions("vKeyBoard", [
      "setKeyBoardDisplay",
      "setKeyBoardInputName",
      "setKeyBoardInput",
    ]),
    setVKB(showKB = true) {
      this.setKeyBoardInputName(this.$refs.input.id);
      if (showKB) this.setKeyBoardDisplay(true);
    },
    keydownInner(event) {
      if (!this.isSpecialKeys(event)) {
        this.handleKeydown(event, this.$refs.input);
      }
      this.doSearch(event);
    },
    doSearch(event, val) {
      let str = event ? event.target.value : val;
      this.searchTxt = str;
      if (!str.trim().length) {
        this.searchResults = [];
        this.$emit("searchResults", this.searchResults);
        return;
      }
      if (str.length == 1) return;

      let interval = 600;

      this.setKeyBoardInput(str);

      //to avoid heavy searches
      if (str.length <= 2) interval = 1000;

      clearTimeout(timeout);
      clearTimeout(timeoutSetActive);
      timeout = setTimeout(() => {
        this.setDoNotFocus(true);
        this.searchResults = bookList.searchByTxt(str);
        this.$emit("searchResults", this.searchResults);
      }, interval);
      timeoutSetActive = setTimeout(() => {}, 800);
    },
    clearTxt() {
      this.$refs.input.focus();
      this.setKeyBoardInput("");
      this.searchTxt = "";
      this.$refs.input.value = "";
    },
  },
  mounted() {
    this.$refs.input.id = `bs_input_${Math.random(1 % 10000000)}`;
  },
  watch: {
    setFocusInInput: function () {
      if (this.$refs.input) this.$refs.input.focus();
    },
    vKeyBoardInput: function (val) {
      if (this.$refs.input.id == this.vKeyBoardInputName) {
        this.$refs.input.value = val;
        this.doSearch(null, val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$bg-color1: #fff;
.div-input {
  padding: 12px 12px 12px;
  position: relative;
  .icon-adv-search {
    position: absolute;
    left: 5px;
    width: 20.3px;
    height: 20.3px;
    border-radius: 50%;
    font-size: 16px;
    font-weight: 900;
    top: 5px;
    line-height: 14px;
    background-color: var(--bg-color2);
    text-align: center;
    cursor: pointer;
    color: var(--text-color2);
  }
}
.icon-search {
  height: 22.5px;
  width: 24px;
  position: absolute;
  right: 4px;
  top: 18.5px;
  position: absolute;
  z-index: 1;
}
input {
  height: 30.54px;
  border-radius: 15px;
  width: 100%;
  background-color: $bg-color1;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  font-size: 16px;
  font-weight: bold;
  color: #000;
  padding: 0 30px 0 22px;
  outline: 0;
  &.input-search {
    text-align: right;
    direction: rtl;
  }
}
input:focus {
  border: 1px solid var(--text-color10);

  // border: 1px solid rgba(0, 0, 0, 0.5);
}
input::placeholder {
  // font-size: 16px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.4);
}
.icon-clear {
  position: absolute;
  top: 0;
  height: 100%;
  left: 34px;
  line-height: 31px;
  font-size: 10px;
}
.redtext {
  color: red !important;
}
.keyboard-icon {
  position: absolute;
  left: 8px;
  top: 5px;
  cursor: pointer;
}
.noactive:active {
  position: 0px;
}
</style>
